const fallback = () => {
  console.error('Incorrect SettingsDialogDataProvider usage.');
  return Promise.reject();
};
const avatarFallback = {
  getAvatar: fallback,
  getName: fallback,
  resolveId: fallback,
  saveAvatar: fallback,
  deleteAvatar: fallback
};
const fallbackSettingsDialogDataProvider = {
  getCustomThemes: fallback,
  getSystemThemes: fallback,
  getDefaultTheme: fallback,
  getAvailableApps: fallback,
  ...avatarFallback
};
export default fallbackSettingsDialogDataProvider;
//# sourceMappingURL=FallbackSettingsDialogDP.js.map